import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import  CustomArtLabel  from './CustomArtLabel';
import ExhibitionService from '../service/ExhibitionService';
import EventBus from "../common/EventBus";
import { useNavigate } from 'react-router-dom';

const CustomFooter = (props) => {
    console.log("CustomFooter props", props)
    const { t } = useTranslation();
    const navigate = useNavigate();


    const [exhibits, setExhibits] = useState([]);

    useEffect(() => {
        loadFeaturedExhibits();
    }, []);

    const prepareExhibits = (param) => {
        let _exhibits = [];
        param.map((item, index) => {
            _exhibits.push({
                id: item.id,
                label: item.exhibitionName,
                image: item.profileImage
            })
        });
        console.log("prepareExhibits", _exhibits)
        setExhibits(_exhibits);
    }
    const loadFeaturedExhibits = async () => {
        setExhibits([]);
        ExhibitionService.inquireFeaturedExhibits().then(
            (response) => {
                console.log("inquireFeaturedExhibits", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFeaturedExhibits", response?.data?.data?.dataList)
                    prepareExhibits(response?.data?.data?.dataList);
                }
            },
            (error) => {

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireExhibitByStatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    props?.toast?.current?.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }

    return (
        <div className="layout-footer-vault grid  flex flex-row align-items-top justify-content-between w-12 ">


            <div className='col-12 md:col-4' >
                <img id="footer-logo" src={`assets/layout/images/logo-${props.themeColor === 'light' ? 'light' : 'dark'}.png`} alt="vault-layout" />
                <div className='text-xl pt-2 pb-2'>{t('footer_text')}</div>
                <div>&#169; Copyright Vault.</div>
            </div>

            <span className="copyright">
                <div className='grid flex flex-row justify-content-end '>
                    <Button className="p-button-rounded p-button-text" label={t('footer_link_about')}
                        onClick={() => {
                            console.log("Eser Seçimi Click");
                            //props.onSelectArtPage();
                        }}
                    />
                    <Button className="p-button-rounded p-button-text" label={t('footer_link_policy')}
                        onClick={() => {
                            console.log("Eser Seçimi Click");
                            //props.onSelectArtPage();
                        }}
                    />
                    <Button className="p-button-rounded p-button-text" label={t('footer_link_contact')}
                        onClick={() => {
                            console.log("Eser Seçimi Click");
                            //props.onSelectArtPage();
                        }}
                    />
                </div>
                <div className='grid flex flex-row justify-content-end pt-4' >{
                    exhibits.map((param, index) => {
                        return (
                            <div key={index} className='pr-2 pb-2 pointer'
                                onClick={() => {
                                    navigate("/exhibition/view/" + param.id);
                                }}
                            >
                                <CustomArtLabel background='rgba(0,0, 0, 0.65)' textColor='white' image={param.image} label={param.label} />
                            </div>
                        )
                    })
                }
                </div>
            </span>

        </div>
    );
}

export default CustomFooter;